const SCROLL_CONTAINER_ID = 'main-content'
const scrollPositions = {}

/**
 * Scrolls the page to the top when navigating to a new page, for DS we want to scroll the main-content instead of the window.
 *
 * @param {object} to
 * @param {object} from
 * @param {object} savedPosition
 * @returns {object|void}
 */
export default function (to, from, savedPosition) {
    const contentEl = document.getElementById(SCROLL_CONTAINER_ID)

    if (to.fullPath === from.fullPath) {
        return
    }

    // For non-ds pages
    if (!contentEl) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }

    const customSavedPosition = scrollPositions[to.fullPath]

    if (customSavedPosition) {
        contentEl.scroll(customSavedPosition)

        delete scrollPositions[to.fullPath]
    } else {
        scrollPositions[from.fullPath] = {
            top: contentEl.scrollTop,
            left: contentEl.scrollLeft,
        }

        contentEl.scroll({
            top: 0,
            left: 0,
        })
    }
}
